import { useIntegratedActionBroadcaster } from '../../action-broadcaster/use-integrated-action-broadcaster';
import { useBroadcast } from '../broadcast-channel/use-broadcast';
import { v4 } from 'uuid';
import { useApplicationType } from './use-application-type';

export function useOpenEventSearch() {
    const { trigger } = useIntegratedActionBroadcaster();
    const { postMessage } = useBroadcast('legacy-store-broadcast');
    const {
        isCadElectronRewrite,
        isCadWeb,
        isCadLegacyElectron,
        isFirstResponder,
    } = useApplicationType();
    const openEventSearch = () => {
        if (isCadElectronRewrite || isCadWeb) {
            trigger([
                {
                    id: v4(),
                    targetWindowType: 'ROOT',
                    type: 'OPEN_EVENT_SEARCH_V2_WINDOW',
                },
            ]);
        } else if (isCadLegacyElectron) {
            postMessage({ type: 'OPEN_EVENT_SEARCH_V2_WINDOW' });
        } else if (isFirstResponder) {
            trigger([
                {
                    id: v4(),
                    targetWindowType: 'ROOT',
                    type: 'CAD_SEARCH',
                },
            ]);
        }
    };
    return openEventSearch;
}
